import { useEffect } from "react"

import type { BulkPriceChangeUpdateInput, PriceChangeItemGroup } from "@/graphql/codegen/graphql"
import { usePriceTableEditsStore } from "@/screens/Pricing/stores/usePriceTableEditsStore"
import { getDefaultedRowKeys } from "@/screens/Pricing/utils/bulkPricePreview"

interface UseDefaultedRowKeysParams {
  groups: PriceChangeItemGroup[]
  bulkUpdate?: BulkPriceChangeUpdateInput
  enabled: boolean
}

export const useDefaultedRowKeys = ({ groups, bulkUpdate, enabled }: UseDefaultedRowKeysParams): void => {
  useEffect(() => {
    if (!enabled || !bulkUpdate) return
    const { edits, addDefaultedRows, removeDefaultedRows } = usePriceTableEditsStore.getState()
    const keys = getDefaultedRowKeys(groups, bulkUpdate, edits)
    addDefaultedRows(keys)
    // Keys follow the loaded page: leaving it (or unmounting) drops them.
    return () => removeDefaultedRows(keys)
  }, [enabled, bulkUpdate, groups])
}
